import { render, staticRenderFns } from "./PagePerformanceReviewTemplate.vue?vue&type=template&id=5464601c&"
import script from "./PagePerformanceReviewTemplate.vue?vue&type=script&lang=js&"
export * from "./PagePerformanceReviewTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports